<template>
	<div class="pdp-default">
		<h2 class="header">
			<span class="pdpTitle">{{ content.pdpTitle }}</span>
		<button v-if="!isXRayEnabled" :aria-label="content.pdpClose" class="close-btn" tabindex="0" @click="closePdp" @keydown.esc="closePdp">
			<img alt="Close" src="/images/icon-close-white.svg" />
		</button>
		</h2>
		<div ref="toastContent" class="content">
			<div :class="`content-container ${flyerOrientation}`">
				<div class="pdpContainer">
				
					<template>
						<h2 v-if="product.productFr!==null" tabindex="0" ref="pdpWindow">{{ product.productFr }}</h2>
						<h2 v-if="product.productEn && product.productFr"> | </h2>
						<h2 v-if="product.productEn !== null"> {{ product.productEn }} </h2>
					</template>

          <div class="productImageContainer">
						<image-magnifier 
							:image-src="product.productImage" 
							:alt-text="product.productEn || product.productFr || 'Product image'"
						/>
					</div>
					


					<div class="price" tabindex="0">
						<h2>
							<span v-if="priceQty">{{ priceQty }} /</span>
							<span v-if="pricePrefix"> {{ pricePrefix }} </span>
							<span> {{ salePrice }}</span>
							<span v-if="promoUnit"> {{ promoUnit }} </span>
							<span v-if="alternatePrice" class="alternatePrice">{{ alternatePrice }}</span>
						</h2>
					</div>

					<div v-if="product.savingsEn" class="savings">
						<span>
							{{ product.savingsPrefix }}
							{{ product.savingsEn }}
							{{ product.savingsSuffix }}</span>
					</div>
					<div v-else-if="product.savingsFr" class="savings">
						<span>
							{{ product.savingsPrefixFr }}
							{{ product.savingsFr }}
							{{ product.savingsSuffixFr }}</span>
					</div>
          <div v-if="showTierEachPrice" class="daysOnly">
            {{ tierEachPrice }}
          </div>          
					<div class="button-container" :class="!isProductURL ? 'visibility': ''">
							   <a v-if="isProductURL" :href="productURLLDF" class="pdp-btn round" target="_blank">
								<span>Shop Now</span>
								<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.6 122.88" style="enable-background:new 0 0 122.6 122.88" xml:space="preserve" width="15px" height="15px">
									<g>
										<path fill="white" d="M110.6,72.58c0-3.19,2.59-5.78,5.78-5.78c3.19,0,5.78,2.59,5.78,5.78v33.19c0,4.71-1.92,8.99-5.02,12.09 c-3.1,3.1-7.38,5.02-12.09,5.02H17.11c-4.71,
										0-8.99-1.92-12.09-5.02c-3.1-3.1-5.02-7.38-5.02-12.09V17.19 C0,12.48,1.92,8.2,5.02,5.1C8.12,2,12.4,0.08,17.11,0.08h32.98c3.19,0,5.78,2.59,5.78,5.78c0,3.19-2.59,
										5.78-5.78,5.78H17.11 c-1.52,0-2.9,0.63-3.91,1.63c-1.01,1.01-1.63,2.39-1.63,3.91v88.58c0,1.52,0.63,2.9,1.63,3.91c1.01,1.01,2.39,1.63,3.91,1.63h87.95 c1.52,0,
										2.9-0.63,3.91-1.63s1.63-2.39,1.63-3.91V72.58L110.6,72.58z M112.42,17.46L54.01,76.6c-2.23,2.27-5.89,2.3-8.16,0.07 c-2.27-2.23-2.3-5.89-0.07-8.16l56.16-56.87H78.56c-3.19,0-5.78-2.59-5.78-5.78c0-3.19,2.59-5.78,5.78-5.78h26.5 c5.12,0,11.72-0.87,15.65,3.1c2.48,2.51,1.93,22.52,1.61,34.11c-0.08,
										3-0.15,5.29-0.15,6.93c0,3.19-2.59,5.78-5.78,5.78 c-3.19,0-5.78-2.59-5.78-5.78c0-0.31,0.08-3.32,0.19-7.24C110.96,30.94,111.93,22.94,112.42,17.46L112.42,17.46z"/>
									</g>
								</svg>
							    </a>
					</div>
					
					<div class="validity">
						<span><strong>{{ content.pdpValidFrom }}</strong></span>
						<div class="date" v-html="flyerDate(product.validFrom, product.validTo)"></div>
					</div>

					<div v-if="product.bodyFr || product.bodyEn" class="detail">
						<span>{{ content.pdpDetails }}</span>
						<p class="detail-content">
							{{ getProductDetail}}
						</p>
					</div>

					<p class="disclaimer-content">{{ content.disclaimer }}</p>

				

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment";
import featureMixin from "@/mixins/featureMixin";
import AppConfig from "@/classes/AppConfig";
import PdpProductMixin from "@/features/pdp/PdpProductMixin";

export default {
	directives: {
		ClickOutside,
	},
	mixins: [featureMixin, PdpProductMixin],

	data() {
		return {
			toastContent: null,
			ready: true
		};
	},
	mounted() {
    /*this.$refs.pdpWindow.focus()*/
		// console.log(this.$refs.pdpPopup);
		/*if(this.enabled){
				const pdpFocus = this.$refs.pdpPopup;
				pdpFocus.focus();
			}*/

	},
	computed: {
		...mapGetters(["content", "language", "isXRayEnabled"]),
		...mapGetters("screen", ["flyerOrientation"]),
		...mapGetters("landingPage", ["currentFlyer"]),
		...mapState("shoppingList", ["shoppingList"]),
		...mapGetters("pdp", { pdpEnabled: "enabled" }),
		...mapGetters('shoppingList', { listEnabled: 'enabled' }),

		columnView() {
			return this.flyerOrientation === "vertical";
		},

		enabled() {
			return this.pdpEnabled && this.config.mode === 'internal';
		},
		getProductDetail() {
			if (this.isRichelieu) {
				return (this.language === 'en') ? this.product.bodyEn : this.product.bodyFr
			} else {
				return this.product.bodyFr && this.product.bodyEn
				   ? `${this.product.bodyFr} | ${this.product.bodyEn}`
								: this.product.bodyFr || this.product.bodyEn
							}
			
		},
		isRichelieu() {
			if (AppConfig.AppConf?.title.toLowerCase().includes("richelieu".toLowerCase())) {
				return true
			} else return false
		},
		isAdonis() {
			if (AppConfig.AppConf?.title.toLowerCase().includes("adonis".toLowerCase())) {
				return true
			} else return false
		},

	},

	methods: {
		...mapActions(["setPdpDisplay", "setCurrentProduct"]),
		...mapActions("shoppingList", ["setAddToList", "setRemoveFromList"]),
		...mapActions("pdp", ["close", "open"]),

		closePdp() {
			this.close();
		},
		handleAddToList(product) {
			// console.log("Handle add to list", product)
			const additionalItemFlag = false;
			this.setAddToList({ product, additionalItemFlag });
		},

		handleRemoveFromList(product) {
			this.setRemoveFromList(product);
		},

		checkProductInSL(product) {
			let item = this.shoppingList.filter(function (e) {
				return e.sku === product.sku;
			});
			return item.length > 0;
		},
		showPriceFr(price) {
			if (!price) return;

			return (
				parseFloat(price)
					.toFixed(2)
					.replace(".", ",") + " $"
			); //adds zeros

		},
		showPriceEn(price) {
			if (!price) return;
			// let enPrice = price.replace(",",".")
			else if (price.includes("$")) {
				let priceWith$ = price.replace("$", "");
				if (priceWith$.includes(",")) {
					let enPrice = priceWith$.replaceAll(",", ".");
					return "$" + enPrice;
				}
				return "$" + priceWith$;
			}
			return "$" + price.replace(",", ".");
		},
		flyerDate(validFrom, validTo) {
			const start = validFrom ? moment.utc(validFrom) : moment.utc(this.currentFlyer.startDate);
			const endDate = validFrom ? moment.utc(validTo) : moment.utc(this.currentFlyer.endDate);
			if (this.language === "en") {
					return `${start.locale('en').format("MMMM D, YYYY")} to ${endDate.locale('en').format("MMMM D, YYYY")}`;
			} else {
					return `${start.format("D MMMM, YYYY").replace("1er", '1<sup style="vertical-align: top; font-size: 8px;">er</sup>')} jusqu'au ${endDate.format("D MMMM, YYYY").replace("1er", '1<sup style="vertical-align: top; font-size: 8px;">er</sup>'
					)}`;
			}
		}
	},

	watch: {
		showPdp(val) {
			if (val) {
				setTimeout(() => {
					this.ready = true;
					const pdpFocus = this.$refs.pdpPopup;
					pdpFocus.focus();
				}, 100);
			}
			this.ready = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.mobile {
	display: none !important;
	flex-flow: column;
	row-gap: 2em;
	padding: 1.5em;

	.description {
		display: flex;
		flex-flow: row;
		text-align: left;
		align-items: flex-end;

		> :first-child {
			width: calc(55px + 1em);
		}

		.mobile-content {
			flex-basis: 100%;
		}
	}
}

.modal-wpr {
	position: absolute;
	top: 0px;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.75);
	z-index: 20;
	display: flex;
	justify-content: flex-start;
	align-items: flex-end;
	flex-flow: column;

	.modal {
		background-color: var(--secondary-color);
		/*margin-top: 75px;*/
		border: 1px solid #bbbbbb;
		/* overflow: auto;*/
		max-height: calc(100% - 1em);
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
		display: flex;
		flex-flow: column;
		max-width: calc(100% - 4em);

		.header {
			background-color: var(--secondary-color);
			color: var(--primary-text-color);
			display: flex;
			justify-content: space-between;
			padding: 10px;

			h2 {
				font-size: 18px;
				text-transform: uppercase;
				font-weight: 400;
			}

			.close-btn {
				cursor: pointer;

				&:hover {
					background: none;
					filter: unset;
				}
			}
		}

		.subtitle {
			padding-top: 6px;
			font-size: 12px;
		}

		.content {
			padding: 8px;
			background-color: #fff;
			color: #545454;
			position: relative;
			flex: 1 0 auto;
			overflow: auto;
			// margin:0px 10px 10px 10px;
			margin: 10px 10px 17px;
			min-height: 250px;
			max-height: calc(100% - 4em);

			/*.scroll-container{
					position: absolute;
					top:0px;
					bottom:0px;
					left:0px;
					right:0px;
				}*/
			.content-container {
				text-align: left;
				//width:300px;
			}

			.f-half {
				display: flex;
				column-gap: 1em;

				flex-direction: column;

				>div {
					flex-basis: 100%;
					display: flex;
					flex-flow: column;
				}
			}

			.content-container {
				// width: 350px;
			}

			.feature {
				background: #eee;
				margin: 12px 0;
				display: flex;
				justify-content: center;
				flex: 1;

				.description {
					display: flex;
					font-size: 14px;
					padding: 15px 0;

					.button-preview {
						display: flex;
						flex-direction: column;
						align-items: center;
						padding: 0 20px;

						h4 {
							text-transform: uppercase;
							padding-top: 16px;
							white-space: nowrap;
						}

						.subtitle {
							text-align: center;
						}
					}
				}
			}
		}
	}
}

.pdpTitle {
	font-size: 18px;
	font-weight: bold;
}

.pdpContainer {
	//margin-left: 10px;
	max-width: calc(100vw - 5em);
//     border: 1px solid #D3D3D3;
//   padding: 10px;

	h2 {
		font-size: 18px;
		line-height: 1.1em;
		display: inline;

	}

    .productImageContainer {
	padding: 5px 0;
	margin-bottom: 10px;
	border: 1px solid #D3D3D3;
	display: flex;
	justify-content: center;

    .productImage {
	// max-height: 60%;
	// max-width: 60%;
	max-height: 200px;
	max-width: 90%;
	width: auto;
	height: auto;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	margin: auto;
  }
  }

 
		
    .language {
		text-wrap: balance;
	}
	

	.productImage {
		// max-height: 60%;
		// max-width: 60%;
		max-height: 200px;
		max-width: 120px;
		width: auto;
		height: auto;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
	}

	.price {
		display: flex;
		color: #ee3124;
		font-weight: 900;
	}

	span.alternatePrice {
		display: inline-block;
	}

	.alternatePrice {
		color: #000;
		font-size: 13px;
		font-weight: normal;
		margin-left: 5px;
	}

	.savings {
		text-transform: uppercase;
    color: #000;
    line-height: 16px;
    font-size: 17px;
    font-weight: 900;
	}

	.detail {
		font-size: 15px;
		margin-top: 10px;
		font-weight: 900;

		.detail-content {
			font-size: 12px;
			font-weight: normal;
		}
	}

	.disclaimer-content {
		font-size: 12px;
    color: #6d6e71;
	margin: 10px 0;
		font-style: italic;
	}

	& .validity {
		font-size: 13px;
		margin-top: 10px;
	}

	.button-container {
		margin-top: 10px;
	
    .pdp-btn.round {
    
    display: inline-flex;
    position: relative;
    background-color:  #005daa;
    width: unset;
    height: unset;
    border-radius: 6px;
    padding: 10px 18px;
    color: white;
      text-decoration: none;
      font-size: 14px;
      font-weight: bold;
    overflow: hidden;
    span {
      margin-right: 10px;
    }
    &:hover {
      filter: brightness(90%);
    }
  
    * {
      -webkit-backface-visibility:unset;
    }
  }
  }
  .button-container.visibility {
    display: none !important;
  }
  .daysOnly {
    margin-top: 8px;
    font-size: 1.1em;
    font-weight: 900;
  }
}

button {
	background: transparent;
	// border: 1px solid #ccc;
	text-transform: uppercase;
	font-weight: 600;
	color: #666;
	border-radius: 4px;
	border: none;
}

button.button {
	background: #fff;
	border: 1px solid #ccc;
	text-transform: uppercase;
	font-weight: 600;
	color: #666;
	padding: 8px 12px;
	border-radius: 4px;
	margin-top: 16px;
}

button.button:hover {
	background: #eee;
	color: #000;
}

.btn {
	background: #fff;
	border: 1px solid #bbb;
	border-radius: 4px;
	padding: 5px;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 34px;
	width: 34px;
	color: #333;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
	cursor: auto;
	pointer-events: none;
}

.addtoList-container {
	margin: 0 10px 0 10px;
}

.pdpAddToList {
	display: flex;
	flex-grow: 0.7;
	cursor: pointer;
	width: 100%;
	border-radius: 5px;
	// margin-top:15px;
	// margin-bottom:15px;
	// margin-right: 10px;
	margin: 15px 0 10px 0;
	background-color: var(--tertiary-color);
	color: #fff;
	padding: 8px;
	justify-content: center;
	max-width: calc(100vw - 7em);
	font-weight: normal;

	&.removeFromList {
		background-color: #EE3124;
	}
}

/* width */
::-webkit-scrollbar {
	width: 15px;
}

/* Track */
::-webkit-scrollbar-track {
	//background: #f1f1f1;
	display: none;
}

/* Handle */
::-webkit-scrollbar-thumb {
	background: #888;
	border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
	background: #555;
}

.btn.page {
	width: 100%;
	height: 28px;
	justify-content: flex-start;
	padding-left: 3%;
	margin-bottom: 8px;

	&+.subtitle {
		text-align: left !important;
	}
}

.page-num {
	background-color: var(--primary-color);
	color: var(--primary-text-color);
	border-radius: 4px;
	font-size: 12px;
	padding: 7px;
}

/*@media only screen and (max-width: 1024px){
    .modal-wpr .modal{
      .content {
        .f-half {
          flex-direction: column !important;
        }
        .content-container{
          width: 925px;
        }
      }
    }
  }*/

.navigation {
	.description {
		flex-basis: 50%;
		justify-content: center;
	}
}

@media only screen and (max-height: 850px) and (min-width: 1024px) {
	.modal-wpr .modal {
		.content {
			.f-half {
				flex-direction: row !important;
			}

			.content-container {
				width: 300px;
			}
		}
	}
}

@media only screen and (max-width: 700px) and (min-width: 558px) {
	.modal-wpr .modal {
		.content {
			.content-container {
				// width: 575px;
			}
		}
	}
}

@media only screen and (max-width: 700px) {
	.modal-wpr .modal {
		.content {
			.content-container {

				//width: 300px;
				.productImage {
					// max-height: 50%;
					// max-width: 50%;
					max-height: 180px;
					max-width: 85px;
				}
			}
		}
	}
}

/* Vertical View Specific */
@media (min-width: 1200px) {
	.modal-wpr .modal.vertical .content .feature.navigation {
		/*.description {
				padding-top: 10px;
				padding-left: 100px;
				padding-bottom: 70px;
				position: relative;
			}*/

		/*.btn.page {
				transform: rotate(90deg);
				width: 146px;
				position: absolute;
				left: 0;
				bottom: 38%;
			}*/

		h4,
		.subtitle {
			text-align: left;
			width: 100%;
		}

		.subtitle+.subtitle {
			margin-top: 1em;
		}
	}

	.content-container {
		width: 300px;
	}
}

@media (max-width: 850px) {
	/*.modal-wpr {
    top: 125px;
  }*/
}

@media (min-width: 850px) and (max-width: 1023px) {
	/*.modal-wpr {
    top: 125px;
  }*/
}

/* Mobile */
@media (min-width: 1024px) and (max-width: 1200px) {

	/*.modal-wpr {
    top: 65px;
  }*/
	.walkthrough {
		display: none;
	}
}

@media (max-width: 1200px) {
	.mobile {
		display: flex !important;
	}

	.desktop {
		display: none !important;
	}

	.modal-wpr .modal {
		/* margin-top: 140px;
			width: 90% !important;*/
		width: 338px;

		.content {
			.f-half {
				/*flex-direction: row !important;*/
			}

			.content-container {
				// width: 400px;
			}
		}

		.header {
			padding-bottom: 4px;

			h2 {
				font-size: 14px;
			}
		}
	}

	.heading {
		display: none;
	}

	.modal-wpr .modal .content .feature {
		display: block;
		background: none;
		padding: 0 6%;

		.description {
			padding: 0;
			margin-bottom: 20px;
			height: 50px;
		}

		.button-preview {
			display: block;
			position: relative;
			padding-left: 60px;
			width: 100%;

			h4 {
				padding: 0;
			}

			.subtitle {
				text-align: left;
			}

			.btn {
				position: absolute;
				top: 0;
				left: 0;
			}
		}
	}

	.subtitle.mobile {
		text-align: center;
		margin-bottom: 20px;
	}
}
</style>
